export default "__VITE_ASSET__CmGQSPfr__"